import { render, staticRenderFns } from "./UploadRetentionIsaDialog.vue?vue&type=template&id=4c972e8d&scoped=true"
import script from "./UploadRetentionIsaDialog.vue?vue&type=script&lang=js"
export * from "./UploadRetentionIsaDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadRetentionIsaDialog.vue?vue&type=style&index=0&id=4c972e8d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c972e8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c972e8d')) {
      api.createRecord('4c972e8d', component.options)
    } else {
      api.reload('4c972e8d', component.options)
    }
    module.hot.accept("./UploadRetentionIsaDialog.vue?vue&type=template&id=4c972e8d&scoped=true", function () {
      api.rerender('4c972e8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UploadRetentionIsaDialog.vue"
export default component.exports